module.exports = __webpack_public_path__ + "img/PL08644.7f8a83d0.png";